(function() {
  const initSlider = () => {
    const sliders = document.querySelectorAll('.popular-products__slider');

    sliders.forEach((slider) => {
      // Destroy existing instance if it exists
      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }

      let columns = Number(slider.dataset.columns) || 4;
      let columnsMobile = Number(slider.dataset.columnsMobile) || 1;

      const container = slider.closest('.popular-products__slider-container');
      const prevButton = container ? container.querySelector('.swiper-button-prev') : null;
      const nextButton = container ? container.querySelector('.swiper-button-next') : null;

      new Swiper(slider, {
        slidesPerView: columnsMobile,
        spaceBetween: 8,
        speed: 600,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 8
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 8
          },
          1360: {
            slidesPerView: columns,
            spaceBetween: 8
          }
        }
      });
    });
  }

  const initSection = () => {
    if (typeof Swiper !== 'undefined') {
      initSlider();
    } else {
      setTimeout(initSection, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSection);
  } else {
    initSection();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initSection, 200);
  });
})();